import axios from "axios";

// The app is always served together with its API under the same host ("/api"
// prefix), so same-origin works for any domain (www, apex, preview, custom).
// Only local development (localhost:3000) needs the explicit backend URL.
const IS_LOCALHOST = ["localhost", "127.0.0.1"].includes(window.location.hostname);
export const BACKEND_URL = IS_LOCALHOST ? process.env.REACT_APP_BACKEND_URL : "";
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "betmar_token";

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const getToken = () => localStorage.getItem(TOKEN_KEY);

export function apiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const formatCOP = (n) =>
  new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", maximumFractionDigits: 0 }).format(n || 0);
